// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","713":"component---src-templates-using-dsg-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"5d9095be72bfbedf1cb7","678":"265f7d0812edcc458f1e","713":"a10089f8db569faca2ef","883":"ef2f81a44b853e2713c3"}[chunkId] + ".js";
};